import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["loader", "loadingSection"];

  startLoading = () => {
    const logoTextField = this.element.querySelector("#site_logo_text");
    const logoPreviewUrlField = this.element.querySelector("#site_logo_preview_url");
    const libraryFileIdField = this.element.querySelector("#site_logo_library_file_id");

    // Check if all necessary fields are empty
    if (!logoTextField.value.trim() && !logoPreviewUrlField.value.trim() && !libraryFileIdField.value.trim()) {
      return;
    }

    $(this.loadingSectionTarget).animate({ opacity: 0.1 }, "fast");
    $(this.loaderTarget).show();
  }
}
